const SERVICE_NAME = 'Подача апелляции на результаты ГИА';

const breadcrumbs = [
  {
    url: '/services/catalog/popular/',
    name: 'Услуги',
  },
  {
    url: '/services/catalog/cat/3532/popular/',
    name: 'Образование',
  },
  {
    url: '/services/podat-apellyatsiyu-na-rezultaty-gia/',
    name: SERVICE_NAME,
  },
  {
    url: '/services/podat-apellyatsiyu-na-rezultaty-gia/new/',
    name: SERVICE_NAME,
    notForHome: true,
  },
  {
    url: '/services/podat-apellyatsiyu-na-rezultaty-gia/',
    name: SERVICE_NAME,
    forMobile: true,
  }
];

export default breadcrumbs;
